import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-310">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between py-4 text-left focus:outline-none" data-id="element-311">
        <span className="text-lg font-medium text-gray-900" data-id="element-312">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-blue-600" data-id="element-313" /> : <ChevronDown className="h-5 w-5 text-gray-400" data-id="element-314" />}
      </button>
      <AnimatePresence data-id="element-315">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-316">
            <div className="pb-4 text-gray-600 leading-relaxed" data-id="element-317">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}